import styled, { css } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: ${props => (props.isBar ? 'row' : 'column')};
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp16};
  padding-bottom: ${props => (props.isBar ? props.theme.spacing.sp16 : props.theme.spacing.sp40)};
  border: ${props => props.theme.stroke.default} dashed ${props => props.theme.colors.disabled.content};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  background-color: ${props => props.theme.colors.disabled.surface};
  color: ${props => props.theme.colors.disabled.content};

  ${props =>
    props.isBar &&
    css`
      justify-content: space-between;
      padding-left: ${props.theme.spacing.sp24};
      padding-right: ${props.theme.spacing.sp24};
    `}

  ${props =>
    props.isBar &&
    props.isMobileView &&
    css`
      flex-direction: column;
      align-items: flex-start;
      gap: ${props.theme.spacing.sp4};
    `}
`

export const Title = styled(Text)`
  align-self: stretch;
  color: ${props => props.theme.colors.disabled.content};

  ${props =>
    props.isBar &&
    css`
      align-self: center;
      white-space: nowrap;
    `}
`

export const ReasonsRow = styled.div`
  display: flex;
  flex-direction: ${props => (props.isBar ? 'row' : 'column')};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const HiddenBy = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  white-space: nowrap;
`

export const ReasonList = styled.ul`
  display: ${props => (props.isBar ? 'flex' : 'block')};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  margin: 0;
  padding: 0;
  padding-left: ${props => (props.isBar ? 0 : props.theme.spacing.sp16)};
  list-style: ${props => (props.isBar ? 'none' : 'disc')};
`

export const Reason = styled.li`
  display: ${props => (props.isBar ? 'flex' : 'list-item')};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  & + & {
    margin-top: ${props => (props.isBar ? 0 : props.theme.spacing.sp8)};
  }

  ${props =>
    props.isBar &&
    css`
      &:not(:first-child)::before {
        content: '|';
      }
    `}
`

export const CriteriaPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding-left: ${props => (props.isBar ? 0 : props.theme.spacing.sp8)};
  padding-top: ${props => (props.isBar ? 0 : props.theme.spacing.sp8)};
`
